import { RequestType } from '../../@theme/type/requestType';
import { ApprovalState } from '../../@theme/type/approvalState';
import { Account } from '../account/account';
import { RequestContext } from './request-context';
import { Message } from '../../common/model/message';
import { RequestSharedDocument } from '../../common/model/request-shared-document';

export class Request {
  id: string;
  type: RequestType = RequestType.CLIENT;
  context: RequestContext;
  state: ApprovalState =  ApprovalState.WAIT;
  createdBy: string;
  created: Date;
  modifiedBy: string;
  modified: Date;
  deleted: Date;
  confirmed: boolean = false;
  companyId: string;
  email: string;
  accountId: string;
  account: Account;
  messageId: string;
  message: RequestSharedDocument;

  constructor(obj?: any) {
    const request = obj || {};
    Object.assign(this, request);
    this.context = request.context ? new RequestContext(request.context) : null;
    this.created = request.created ? new Date(request.created) : null;
    this.modified = request.modified ? new Date(request.modified) : null;
    this.account = request.account ? new Account(request.account) : null;
    this.message = request.message ? new RequestSharedDocument(request.message) : null;
  }
}
